import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { getCities } from 'models/cities'; // Importing getCities function from cities model
import { getTags } from 'models/tags'; // Importing getTags function from tags model
import { getPositions } from 'models/positions'; // Importing getPositions function from positions model
import 'webix/photo'; // Importing webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix

/**
 * Class representing a filter submenu view.
 * @extends JetView
 */
export default class FilterSubMenuView extends JetView {
    /**
     * Configures the layout of the filter submenu.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const screen = this.app.config.size; // Get the current screen size

        const left = {
            // Left section of the form
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row', // CSS class for styling
                    cols: [
                        {
                            view: 'text', // Text input for Description
                            name: 'Description',
                            label: "<span class='icon-file-text1'></span>" + _('Descripción'), // Label with icon
                            labelPosition: 'top',
                            placeholder: _('Descripción'), // Placeholder text
                            invalidMessage: _('Descripción is required'), // Validation message
                        },
                        {
                            view: 'text', // Text input for Page
                            name: 'Page',
                            label: _('Página'),
                            labelPosition: 'top',
                            placeholder: _('Página'),
                            invalidMessage: _('Página is required'), // Validation message
                        },
                        {
                            view: 'text', // Text input for Menu
                            name: 'Menu',
                            label: _('Menu'),
                            labelPosition: 'top',
                            placeholder: _('Menu'),
                            invalidMessage: _('Menu is required'), // Validation message
                        },
                    ],
                },
            ],
        };

        const upper_section = {
            // Upper section of the form
            css: 'father-container', // CSS class for styling
            height: document.body.offsetWidth < 500 ? 180 : 0, // Conditional height based on screen width
            rows: [
                {
                    margin: 10,
                    cols: [left], // Include left section
                },
            ],
        };

        const buttons = {
            // Button section
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2', // Responsive design identifier
                    cols: [
                        { id: 'grav', gravity: 4 }, // Gravity for layout management
                        {
                            view: 'button', // Clear button
                            value: _('Limpiar'), // Button label
                            width: screen == 'small' ? 0 : 100, // Conditional width based on screen size
                            minWidth: 200,
                            click: () => {
                                // Click event handler
                                this.getRoot().clear(); // Clear the form
                            },
                        },
                        {
                            view: 'button', // Consult button
                            value: _('Consultar'), // Button label
                            type: 'form', // Button type
                            width: screen == 'small' ? 0 : 100, // Conditional width based on screen size
                            minWidth: 200,
                            click: () => {
                                // Click event handler
                                const filterdata = this.getRoot().getValues(); // Get form values
                                this.app.callEvent('submenu:filter', [filterdata]); // Trigger filter event with data
                            },
                        },
                    ],
                },
            ],
        };

        return {
            // Return the complete form configuration
            view: 'form',
            rows: [upper_section, buttons], // Include upper section and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view.
     * @param {Object} grid - The grid object passed to the init function.
     */
    init(grid) {
        webix.ready(function () {
            // Wait for webix to be ready
            if (screen.width < 500) {
                // Check screen width
                $$('grav').hide(); // Hide element if screen is small
            }
        });
    }
}

// FILE DOCUMENTED
